import { CategoryConfigManager } from "@/components/admin/CategoryConfigManager";

export default function ProductCategories() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Product Category Configuration</h1>
        <p className="text-muted-foreground mt-2">
          Configure how product categories behave in estimates and presentations
        </p>
      </div>

      <CategoryConfigManager />
    </div>
  );
}
